import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

/**
 * Admin Console Entry Point
 * Redirects to /admin/console/users
 */
const AdminConsoleMain = ({ auth }) => {
  const history = useHistory();

  useEffect(() => {
    if (auth === null || auth === undefined) return;
    if (auth === false) {
      history.push('/');
      return;
    }
    if (!auth.id || auth.role !== 'admin') {
      history.push('/');
      return;
    }
    // Redirect to users page
    history.push('/admin/console/users');
  }, [auth, history]);

  return null;
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(AdminConsoleMain);
